var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.updateExists)?_c('div',{staticClass:"wrap"},[_vm._v("Aktualisierung verfügbar "),_c('button',{staticClass:"btn",on:{"click":_vm.refreshApp}},[_vm._v("aktualisieren")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }